import React, { Component } from "react";
import {
  View,
  ScrollView,
  StyleSheet,
  Dimensions,
  Platform,
  TouchableHighlight,
} from "react-native";
import Text from "./TextFont";
import { connect } from "react-redux";
import * as faCharCodes from "../../assets/consts/faCharCodes";
import { IconButton, ShortcutButton, SimpleIcon } from "./Buttons";
import { translate } from "../locales/translate";
import * as DeviceTypes from "../components/devices/_deviceTypes";
import * as AreaActions from "../actions/AreaActions";
import * as AppActions from "../actions/AppActions";
import * as UserActions from "../actions/UserActions";
import * as ScenarioActions from "../actions/ScenarioActions";
import * as DoorlockActions from "../actions/DoorlockActions";
import * as CONSTANTS from "../../assets/consts";
import * as SecureStore from "./DeviceAsyncStorage";
import * as SirenActions from "../actions/SirenActions";

import ArTheme from "../argon-ui/Theme";
import ArButton from "../argon-ui/Button";
import SearchableDropdown from "../components/SearchableDropDown";
import Spinner from "../components_v2/Spinner";
import { getIconByDeviceType } from "../actions/DeviceHelper";
import FontAwesomeIcon from "./FontAwesomeIcon";
import Select from "../nativeBase-ui/Select";
import runResultHandler from "../components/runResultHandler";
import AlertDialogBase from "../nativeBase-ui/AlertDialog";
import ModalBase from "../nativeBase-ui/ModalBase";
import { HStack } from "native-base";


const WINDOW_WIDTH = Dimensions.get("window").width;

const RADIUS = 5;
class InsideDropdown extends Component {
  render() {
    let { data, value, onChangeText } = this.props;
    if (Platform.OS === "web") {
      return (
        <ScrollView style={{ flex: 1 }}>
          <SearchableDropdown
            clearable={false}
            isSearchable={false}
            items={data.map((d) => {
              return { id: d.value, name: d.label };
            })}
            selectedValue={value}
            onSelect={(val) => {
              typeof onChangeText === "function" && onChangeText(val);
            }}
          />
        </ScrollView>
      );
    } else {
      return (
        <Select
          data={data}
          value={value}
          onChangeText={(val) => {
            typeof onChangeText === "function" && onChangeText(val);
          }}
        />
      );
    }
  }
}
const RenderIconListWrapper = (props) => {
  const { children, isOpenDropdown } = props;
  return (
    <ScrollView
      horizontal={true}
      contentContainerStyle={[
        // styles.iconsWrapper,
        {
          flexGrow: 1,
          // width:"100%",
          // flex: 1,
          padding: 5,
          backgroundColor: "#fff",
          borderTopEndRadius: RADIUS,
          maxHeight: 155,
          marginTop: 5,
        },
      ]}
    >
      {children}
    </ScrollView>
  );
};
class ShortcutBoard extends Component {
  constructor(props) {
    super(props);
    this.deviceTypes = [DeviceTypes.DOORLOCK];
    this.state = {
      accessToken: null,
      fontsLoaded: false,
      quickAccessList: undefined,
      tempList: [],
      isEditing: false,
      isModalVisible: false,
      selectedAreaFilter: undefined,
      selectedDeviceTypeFilter: this.deviceTypes[0],
      selectedCustomIcon: undefined,
      selectedDeviceFilter: undefined,
      scenarioIdToRun: undefined,
      scenarioUIdToRun: undefined,
      isShowingScenarioConfirm: false,
      validationMessage: undefined,
      sirenId: null,
      // === Modal ===
      isModalVisibleScenario: false,
      // === Dropdown ShortcutBoard ===
      isOpenDropdown: false,
      // === kiosk mode ===

      // === run scenario result === => To make the difference between running the scenario in the shortcutBoard and scenarioSummary
      // Because in the shortcut, runResult is immediately empty, but in the runResult scenario, the user is empty
      runScenario: false,
    };

    this.hvacMenuRef = undefined;

    this.customIcons = {};

    // grouped by deviceType name
    this.customIcons[DeviceTypes.DOORLOCK] = [
      faCharCodes.faKey,
      faCharCodes.faKeySkeleton,
      faCharCodes.faToriiGate,
      faCharCodes.faDungeon,
      faCharCodes.faDoorOpen,
      faCharCodes.faDoorClosed,
      faCharCodes.faWarehouse,
    ];
  }

  componentDidMount() {
    const { currentServer } = this.props.AppReducer;
    this.setState({ accessToken: currentServer.accessToken });
  }
  // ** use CacheStorage
  // loadDeviceListLocally = () => {
  // SecureStore.getItemAsync(CONSTANTS.USER_QUICK_ACCESS)
  //   .then((quickAccessListJson) => {
  //     var quickAccessList = JSON.parse(quickAccessListJson);
  //     if (Array.isArray(quickAccessList)) {
  //       //this.setState({ quickAccessList });
  //       this.props.updateQuickAccessListLocally(quickAccessList);
  //     } else {
  //       //this.setState({ quickAccessList: [] });
  //     }
  //   })
  //   .catch((e) => {
  //     //this.setState({ quickAccessList: [] });
  //     console.log(e);
  //   });
  // };

  refreshDevicesList = () => {
    this.props.refreshDevicesList(this.state.accessToken);
  };

  updateDevicesList = () => {
    if (this.props.UserReducer.quickAccess != undefined) {
      var devicesIdList = this.props.UserReducer.quickAccess.map(
        (d) => d.deviceId || d.deviceUId
      );
      this.props.updateDevicesList(devicesIdList, this.state.accessToken);
    }
  };

  turnOffLights = () => {
    this.props.turnOffAllLights(
      this.state.accessToken,
      this.props.areaId,
      this.props.areaUId
    );
  };

  openBlinds = () => {
    this.props.openAllCurtains(
      this.state.accessToken,
      this.props.areaId || this.props.areaUId
    );
  };

  closeBlinds = () => {
    this.props.closeAllCurtains(
      this.state.accessToken,
      this.props.areaId || this.props.areaUId
    );
  };
  //////////////////////////////////
  // quick access
  showModal = () => {
    this.setState({ isModalVisible: true });
  };

  hideModal = () => {
    this.setState({ isModalVisible: false, validationMessage: undefined });
  };

  addToTempList = (_deviceId, customIcon) => {
    let device = this.props.DeviceReducer.list.find((d) =>
      typeof _deviceId == "number"
        ? d.deviceId == _deviceId
        : d.deviceUId == _deviceId
    );
    if (device) {
      if (
        this.state.tempList.some((t) =>
          typeof _deviceId == "number"
            ? t.deviceId == _deviceId
            : t.deviceUId == _deviceId
        )
      ) {
        this.setState({ validationMessage: translate("app.duplicatedItem") });
        return;
      }
      let newTemp = [...this.state.tempList];
      let { deviceType, deviceName, deviceId, deviceUId } = device;
      let addedDevice = {
        deviceId,
        deviceUId,
        deviceType,
        deviceName,
        customIcon,
      };
      // replace with first empty slot
      if (newTemp.some((t) => t.deviceType == "EMPTY")) {
        for (var i in newTemp) {
          if (newTemp[i].deviceType == "EMPTY") {
            newTemp[i] = addedDevice;
            break;
          }
        }
      }
      // or just push as new item if no empty slot found
      else {
        newTemp.push(addedDevice);
      }

      this.setState({
        tempList: newTemp,
        selectedDeviceFilter: undefined,
        selectedCustomIcon: undefined,
        validationMessage: undefined,
      });
    }

    this.hideModal();
  };

  removeFromTempList = (deviceId) => {
    const isDeviceIdNumber = typeof deviceId == "number" ? true : false;
    for (var i in this.state.tempList) {
      const tempItem = this.state.tempList[i];
      if (
        isDeviceIdNumber
          ? tempItem.deviceId == deviceId
          : tempItem.deviceUId == deviceId
      ) {
        let newTemp = [...this.state.tempList];
        newTemp.splice(i, 1);
        this.setState({ tempList: newTemp });
        return;
      }
    }
  };

  startEdit = () => {
    this.setState({
      isEditing: true,
      tempList: [...this.props.UserReducer.quickAccess],
    });
  };

  applyEdit = () => {
    var finalList = [...this.state.tempList];
    // update state
    this.setState({
      isEditing: false,
      tempList: [],
    });

    // update secure store for next run
    SecureStore.setItemAsync(
      CONSTANTS.USER_QUICK_ACCESS,
      JSON.stringify(finalList)
    );

    // update store
    this.props.updateQuickAccessListLocally(finalList);
    // send data to server
    this.props.updateQuickAccessList(
      finalList.map((d) => {
        return {
          deviceId: d.deviceId,
          deviceUId: d.deviceUId,
          customIcon: d.customIcon,
        };
      }),
      this.state.accessToken
    );
  };

  cancelEdit = () => {
    this.setState({
      isEditing: false,
      tempList: [],
    });
  };
  // end of quick access
  //////////////////////////////////

  navigateToScenarios = () => {
    this.props.navigation && this.props.navigation.navigate("Scenarios");
  };

  showUnlockDoorConfirm(deviceId, deviceUId) {
    typeof this.props.onShowUnlockDoorLockAlert === "function" &&
      this.props.onShowUnlockDoorLockAlert(deviceId, deviceUId);
  }

  hideRunScenarioConfirm() {
    this.setState({
      isShowingScenarioConfirm: false,
      isModalVisibleScenario: false,
      scenarioIdToRun: undefined,
      scenarioUIdToRun: undefined,
    });
  }
  showRunScenarioConfirm(scenarioId, scenarioUId) {
    this.setState({
      isShowingScenarioConfirm: true,
      isModalVisibleScenario: true,
      scenarioIdToRun: scenarioId,
      scenarioUIdToRun: scenarioUId,
    });
  }
  runSelectedScenario() {
    let { scenarioIdToRun, scenarioUIdToRun, accessToken } = this.state;
    if (scenarioIdToRun) {
      this.setState({ runScenario: true }, () => {
        this.props.runScenario(scenarioIdToRun, scenarioUIdToRun, accessToken);
      });
    }
    this.hideRunScenarioConfirm();
  }

  toggleDropdown() {
    this.setState({ isOpenDropdown: !this.state.isOpenDropdown });
  }
  handleDisableMessageScenario = (scenarioName) => {
    const messageToast = {
      title: translate("scenario.disableScenarioMessage", {
        scenarioName,
      }),
      variant: "top-accent",
      status: "info",
      duration: 2500,
    };
    this.props.messageToast(messageToast);
  };
  render() {
    if (this.props.UserReducer.quickAccess == undefined) {
      // return empty view instead of null to support web
      return <View></View>;
    }
    var scenariosShortcut = this.props.ScenarioReducer.scenarios.filter(
      (s) => s.showDashboardShortcut && s._mainConditionType != "device"
    );
    var userDefinedStates = [];
    for (let i = 0; i < this.props.AreaReducer.areas.length; i++) {
      const area = this.props.AreaReducer.areas[i];
      if (area && area.userDefinedStates && area.userDefinedStates.length > 0) {
        for (const j in area.userDefinedStates) {
          const areaState = area.userDefinedStates[j];
          if (areaState.canShowOnHomeScreen) {
            userDefinedStates.push({ ...areaState, deviceType: "AREA_STATE" });
          }
        }
      }
    }
    var turnOnSiren = this.props.DeviceReducer.list.filter((o) => {
      if (o.deviceType == "SIREN" && o.isTurnedOn) return o;
    });
    var iconsList = this.state.isEditing
      ? [...this.state.tempList, { deviceType: "EMPTY" }]
      : [
          ...this.props.UserReducer.quickAccess,
          ...scenariosShortcut,
          ...userDefinedStates,
        ];
    //var columns = 4;
    var _style = this.props.style || {};
    // === 80 =>  minWidth icons ===
    let iconL = iconsList.length * 80;
    let widthW = Math.round(WINDOW_WIDTH / 3.5);
    var isScrollIconListWrapper = iconL > widthW;

    // === scenario run result ===
    let runResult = null;
    if (this.state.runScenario) {
      const { runResult: _runResult, scenarios } = this.props.ScenarioReducer;
      const { list: devices } = this.props.DeviceReducer;
      const { areas } = this.props.AreaReducer;
      if (_runResult) {
        // === return toast detail ===
        runResult = runResultHandler(_runResult, scenarios, devices, areas);
        if (runResult) {
          this.setState({ runScenario: false }, () => {
            this.props.messageToast(runResult);
            this.props.clearRunResult();
            runResult = null;
          });
        }
      }
    }
    return (
      <View
        style={[
          {
            // maxWidth: CONSTANTS.WEB_MAX_WIDTH,
            width: "100%",
            backgroundColor: "#FFF",
            borderRadius: RADIUS,
            //paddingVertical: 5,
            marginTop: 10,
            padding: 5,
            position: "relative",
          },
          _style,
        ]}
      >
        {/** devices */}
        <View style={{ flexDirection: "row" }}>
          {/* add new shortcut buttons */}
          <View
            style={[
              {
                backgroundColor: "#dde2ed",
                // paddingHorizontal: 5,
                justifyContent: "center",
                alignItems: "center",
                borderRadius: RADIUS / 2,
                // marginBottom: 10,
                maxWidth: 105,
              },
            ]}
          >
            {iconsList.length == 0 && (
              <TouchableHighlight
                onPress={() => {
                  this.startEdit();
                  this.showModal();
                }}
                underlayColor="transparent"
                style={[
                  styles.btnAddShortcut,
                  { paddingVertical: 10, width: "100%", padding: 5 },
                  ,
                ]}
              >
                <View
                  style={[
                    {
                      alignItems: "center",
                      flexDirection: "column",
                    },
                  ]}
                >
                  <SimpleIcon
                    icon={faCharCodes.faPlus}
                    style={{ marginHorizontal: 5 }}
                    size={16}
                    color={ArTheme.COLORS.DEFAULT}
                  />
                  <Text style={{ color: ArTheme.COLORS.DEFAULT, fontSize: 11 }}>
                    {translate("v2Dashboard.newShortcut")}
                  </Text>
                </View>
              </TouchableHighlight>
            )}
            {!iconsList.length == 0 && (
              <View
                style={[
                  {
                    flexDirection: "column",
                    justifyContent:
                      iconsList.length > 6
                        ? "space-between"
                        : this.state.isEditing
                        ? "space-between"
                        : "center",
                    alignItems: "center",
                    minHeight: 40,
                    width: "100%",
                  },
                ]}
              >
                <View
                  style={{
                    flexDirection: "row",
                    justifyContent: "flex-start",
                    alignItems: "center",
                  }}
                >
                  {iconsList.length > 0 && (
                    <TouchableHighlight
                      onPress={() => {
                        this.startEdit();
                      }}
                      underlayColor="transparent"
                      style={[styles.btnAddShortcut, { width: 35 }]}
                    >
                      <View
                        style={{
                          alignItems: "center",
                        }}
                      >
                        <SimpleIcon
                          icon={faCharCodes.faEdit}
                          size={18}
                          color={ArTheme.COLORS.DEFAULT}
                        />
                        {/* <Text style={{ color: ArTheme.COLORS.DEFAULT, fontSize: 11 }}>
                    {translate("v2Dashboard.editShortcuts")}
                  </Text> */}
                      </View>
                    </TouchableHighlight>
                  )}
                </View>
                {this.state.isEditing && (
                  <View
                    style={[
                      {
                        flexDirection: "row",
                        alignItems: "center",
                        justifyContent: "center",
                        marginTop: 10,
                        // backgroundColor: "#dde2ed",
                        // borderColor: "red",
                        // borderWidth: 1,
                        // marginTop: 15,
                        // marginBottom: 5,
                      },
                    ]}
                  >
                    <IconButton
                      onPress={this.applyEdit}
                      style={[styles.btnEditShortcut]}
                      icon={{
                        code: faCharCodes.faCheck,
                        style: {
                          color: ArTheme.COLORS.WHITE,
                          fontFamily: "FontAwesomeProLight",
                          textAlign: "center",
                          fontSize: 13,
                        },
                      }}
                    />
                    <IconButton
                      onPress={this.cancelEdit}
                      style={[styles.btnEditShortcut]}
                      icon={{
                        code: faCharCodes.faTimes,
                        style: {
                          color: ArTheme.COLORS.WHITE,
                          fontFamily: "FontAwesomeProLight",
                          textAlign: "center",
                          fontSize: 15,
                        },
                      }}
                    />
                  </View>
                )}
              </View>
            )}
          </View>
          {isScrollIconListWrapper && (
            <View
              style={{ position: "absolute", top: 114, right: 0, zIndex: 1 }}
            >
              <FontAwesomeIcon
                icon={faCharCodes.faChevronDoubleLeft}
                size={18}
                color={ArTheme.COLORS.LIGHT_MAIN}
              />
            </View>
          )}
          {/* spacer */}
          {/* {iconsList.length == 0 && ()} */}
          {(turnOnSiren.length > 0 || iconsList.length > 0) && (
            <RenderIconListWrapper isOpenDropdown={this.state.isOpenDropdown}>
              {/* <Text
                style={{
                  fontSize: 18,
                  fontWeight: "bold",
                  color: "#eee", //ArTheme.COLORS.INPUT,
                }}
              >
                {translate("v2Dashboard.quickAccess")}
              </Text> */}

              {turnOnSiren.length > 0 &&
                turnOnSiren.map((o, i) => {
                  return (
                    <ShortcutButton
                      key={o.deviceId}
                      onPress={() => {
                        typeof this.props.onTurnOffSiren === "function";
                        this.props.onTurnOffSiren(
                          o.deviceId,
                          o.deviceUId,
                          o.deviceName
                        );
                      }}
                      isRemovable={false}
                      style={{
                        hexColor: "#802348",
                        hexColorIcon: "#d9004c",
                      }}
                      icon={{
                        code: getIconByDeviceType(DeviceTypes.SIREN),
                        caption: o.deviceName,
                      }}
                    />
                  );
                })}

              {iconsList.map((d, i) => {
                switch (d.deviceType) {
                  case DeviceTypes.DOORLOCK:
                    return (
                      <View key={i}>
                        <ShortcutButton
                          onPress={() => {
                            !this.state.isEditing &&
                              this.showUnlockDoorConfirm(
                                d.deviceId,
                                d.deviceUId
                              );
                          }}
                          onDelete={() => {
                            this.removeFromTempList(d.deviceId || d.deviceUId);
                          }}
                          isRemovable={this.state.isEditing}
                          style={{
                            hexColor: "#666699",
                          }}
                          icon={{
                            code: d.customIcon || faCharCodes.faKey,
                            caption: d.deviceName,
                          }}
                        />
                      </View>
                    );

                  case "EMPTY":
                    return (
                      <ShortcutButton
                        key={i}
                        onPress={() => this.showModal(i)}
                        style={{
                          hexColor: ArTheme.COLORS.DEFAULT,
                        }}
                        icon={{
                          code: faCharCodes.faPlus,
                          caption: d.deviceName,
                        }}
                      />
                    );

                  case "AREA_STATE":
                    if (d.isLoading) {
                      return (
                        <View
                          key={i}
                          style={{
                            maxWidth: "25%",
                            minWidth: 80,
                            alignItems: "center",
                            justifyContent: "space-between",
                          }}
                        >
                          <Spinner
                            size={35}
                            style={{ top: 0, marginBottom: 6 }}
                          />
                          <Text style={{ color: ArTheme.COLORS.MUTED }}>
                            {d.name}
                          </Text>
                        </View>
                      );
                    } else {
                      return (
                        <ShortcutButton
                          key={i}
                          onPress={() => {
                            // console.log("user defined state shortcut", d);

                            // check if should confirm
                            var shouldConfirm = false;
                            if (
                              Array.isArray(d.devicesStatus) &&
                              d.devicesStatus.some(
                                (dvc) => dvc.manager == "DoorLockManager"
                              )
                            ) {
                              shouldConfirm = true;
                            } else if (
                              Array.isArray(d.scenariosToRun) &&
                              d.scenariosToRun.length > 0
                            ) {
                              for (var s in d.scenariosToRun) {
                                let scnId = d.scenariosToRun[s].scenarioId;
                                let scnUId = d.scenariosToRun[s].scenarioUId;
                                var scn =
                                  this.props.ScenarioReducer.scenarios.find(
                                    (sc) =>
                                      sc.id == scnId ||
                                      (scnUId && sc.uId == scnUId)
                                  );
                                if (
                                  scn &&
                                  Array.isArray(scn.actions) &&
                                  scn.actions.some(
                                    (sa) =>
                                      sa.manager == "DoorLockManager" &&
                                      (sa.action == "Open" ||
                                        sa.action == "OpenAll")
                                  )
                                ) {
                                  shouldConfirm = true;
                                }
                              }
                            }
                            shouldConfirm =
                              shouldConfirm || // either door lock action is presented
                              d.shouldConfirm; // or forced by entity object
                            // end check if should confirm
                            if (d.isActivated) {
                              if (shouldConfirm) {
                                typeof this.props.onChangeAreaStateConfirm ===
                                  "function" &&
                                  this.props.onChangeAreaStateConfirm(
                                    d.id,
                                    d.uId,
                                    d.name,
                                    "deActivate"
                                  );
                              } else {
                                // else, deActivateState immediately
                                this.props.deActivateState(
                                  d.id,
                                  d.uId,
                                  this.state.accessToken
                                );
                              }
                            } else {
                              if (shouldConfirm) {
                                typeof this.props.onChangeAreaStateConfirm ===
                                  "function" &&
                                  this.props.onChangeAreaStateConfirm(
                                    d.id,
                                    d.uId,
                                    d.name,
                                    "activate"
                                  );
                              } else {
                                // else, activateState immediately
                                this.props.activateState(
                                  d.id,
                                  d.uId,
                                  this.state.accessToken
                                );
                              }
                            }
                          }}
                          style={{
                            hexColor: d.isActivated
                              ? ArTheme.COLORS.DEFAULT
                              : ArTheme.COLORS.MUTED,
                          }}
                          icon={{
                            code: d.isActivated ? d.activeIcon : d.deActiveIcon,
                            caption: d.name,
                          }}
                        />
                      );
                    }
                  // deviceType for scenarios is undefined
                  case undefined:
                    // scenario
                    var mainCondition = d.conditions?.filter(
                      (c) => c.isMain
                    )[0];
                    var customIcon = undefined;
                    if (mainCondition) customIcon = mainCondition.iconName;
                    return (
                      <ShortcutButton
                        typeShortcut="scenario"
                        enable={d.enable}
                        key={i}
                        onPress={() => {
                          !this.state.isEditing &&
                            d.enable &&
                            this.showRunScenarioConfirm(d.id, d.uId);
                          // === show toast for disable scenario
                          !this.state.isEditing &&
                            !d.enable &&
                            this.handleDisableMessageScenario(d.name);
                        }}
                        style={{
                          hexColor: ArTheme.COLORS.PRIMARY,
                        }}
                        icon={{
                          code:
                            d._mainConditionType == "schedule"
                              ? faCharCodes.faStopwatch
                              : d.customIcon ||
                                customIcon ||
                                faCharCodes.faMagic,
                          caption: d.name,
                          style: {
                            fontFamily: "FontAwesomeProLight",
                          },
                        }}
                      />
                    );
                }
              })}
            </RenderIconListWrapper>
          )}
        </View>

        {/* pick shortCut modal */}
        {this.state.isModalVisible && (
          <ModalBase
            closeIcon={false}
            isOpen={this.state.isModalVisible}
            onClose={this.hideModal}
            contentStyle={{ height: "100%" }}
          >
            <ScrollView style={styles.modalInsideWrapper}>
              <View style={{ flex: 1 }}>
                <View style={styles.modalFilterWrapper}></View>
                {/**area filter */}
                <View style={styles.modalFilterWrapper}>
                  <Text>{translate("area.areaName")}</Text>
                  <InsideDropdown
                    data={this.props.AreaReducer.areas.map((a) => {
                      return {
                        value: a.areaId || a.areaUId,
                        label: a.areaName,
                      };
                    })}
                    value={this.state.selectedAreaFilter}
                    onChangeText={(value, index, data) => {
                      this.setState({ selectedAreaFilter: value });
                    }}
                  />
                </View>
                {/**device type filter */}
                <View style={styles.modalFilterWrapper}>
                  <Text>{translate("device.deviceType")}</Text>
                  <InsideDropdown
                    data={this.deviceTypes.map((dt) => {
                      return {
                        value: dt,
                        label: translate(`deviceGroup.${dt}`),
                      };
                    })}
                    value={this.state.selectedDeviceTypeFilter}
                    onChangeText={(value, index, data) => {}}
                  />
                </View>
                {/**device filter */}
                <View style={styles.modalFilterWrapper}>
                  <Text>{translate("device.devices")}</Text>
                  <InsideDropdown
                    data={[
                      { value: undefined, label: translate("device.none") },
                      ...this.props.DeviceReducer.list
                        .filter((d) => {
                          const findArea = this.props.AreaReducer.areas.find(
                            (a) =>
                              typeof this.state.selectedAreaFilter == "number"
                                ? a?.areaId == this.state.selectedAreaFilter
                                : a?.areaUId == this.state.selectedAreaFilter
                          );
                          const areaDevices = findArea
                            ? typeof this.state.selectedAreaFilter == "number"
                              ? findArea?.devices.indexOf(d.deviceId) >= 0
                              : findArea?.uDevices.indexOf(d.deviceUId) >= 0
                            : null;
                          return (
                            d.deviceType ==
                              this.state.selectedDeviceTypeFilter &&
                            d.showOnHomeScreen &&
                            this.props.AreaReducer.areas &&
                            findArea &&
                            areaDevices
                          );
                        })
                        .map((d) => {
                          return {
                            value:
                              typeof this.state.selectedAreaFilter == "number"
                                ? d.deviceId
                                : d.deviceUId,
                            label: d.deviceName,
                          };
                        }),
                    ]}
                    //value={}
                    onChangeText={(value, index, data) => {
                      this.setState({
                        selectedDeviceFilter: value,
                        validationMessage: undefined,
                      });
                    }}
                  />
                </View>
                {/**custom Icon */}
                {this.customIcons[this.state.selectedDeviceTypeFilter] && (
                  <View style={styles.modalFilterWrapper}>
                    <Text>{translate("device.customIcon")}</Text>
                    <ScrollView
                      horizontal
                      style={{
                        backgroundColor: ArTheme.COLORS.BORDER_COLOR,
                        paddingVertical: 5,
                      }}
                    >
                      {this.customIcons[
                        this.state.selectedDeviceTypeFilter
                      ].map((ic, idx) => (
                        <IconButton
                          key={idx}
                          onPress={() => {
                            this.setState({ selectedCustomIcon: ic });
                          }}
                          style={{
                            borderWidth: 1,
                            borderColor: ArTheme.COLORS.BORDER,
                            width: 42,
                            height: 42,
                            borderRadius: RADIUS,
                            margin: 3,
                            backgroundColor: "#FFF",
                            justifyContent: "center",
                          }}
                          icon={{
                            code: ic,
                            style: {
                              color:
                                this.state.selectedCustomIcon == ic
                                  ? ArTheme.COLORS.ACTIVE
                                  : ArTheme.COLORS.MUTED,
                              fontFamily:
                                this.state.selectedCustomIcon == ic
                                  ? faCharCodes.FONT_FAMILIES.PRO_REGULAR
                                  : faCharCodes.FONT_FAMILIES.PRO_LIGHT,
                              fontSize: 27,
                            },
                          }}
                        />
                      ))}
                    </ScrollView>
                  </View>
                )}
                {/**validation message */}
                {this.state.validationMessage != undefined && (
                  <View style={styles.modalFilterWrapper}>
                    <Text style={{ textAlign: "center", color: "#F00" }}>
                      {this.state.validationMessage}
                    </Text>
                  </View>
                )}
              </View>
              {/* end close button */}
            </ScrollView>
            <HStack space="2" style={{ padding: 10 }}>
              {/* submit button */}
              <ArButton
                color="primary"
                onPress={() => {
                  if (this.state.selectedDeviceFilter) {
                    this.addToTempList(
                      this.state.selectedDeviceFilter,
                      this.state.selectedCustomIcon
                    );
                  }
                }}
                style={{
                  ...styles.modalBtn,
                }}
              >
                {translate("app.confirm")}
              </ArButton>
              {/* end submit button */}
              {/* close button */}
              <ArButton
                color="muted"
                variant="outline"
                onPress={this.hideModal}
                style={{
                  ...styles.modalBtn,
                }}
              >
                {translate("app.close")}
              </ArButton>
            </HStack>
          </ModalBase>
        )}
        {/* run scenario confirm */}
        {this.state.isModalVisibleScenario && (
          <AlertDialogBase
            isOpen={true}
            colorConfirm="primary"
            title={
              translate("v2Dashboard.Scenario") +
              ` : ${
                this.props.ScenarioReducer.scenarios.find((s) => {
                  return (
                    s.id == this.state.scenarioIdToRun ||
                    (s.uId && s.uId == this.state.scenarioUIdToRun)
                  );
                })?.name
              }`
            }
            confirmText={translate("app.confirm")}
            confirmHandler={() => {
              this.runSelectedScenario();
            }}
            onClose={() => this.hideRunScenarioConfirm()}
          >
            <Text>
              {translate("scenario.scenarioRunConfirm", {
                scenarioName: this.props.ScenarioReducer.scenarios.find((s) => {
                  return (
                    s.id == this.state.scenarioIdToRun ||
                    (s.uId && s.uId == this.state.scenarioUIdToRun)
                  );
                })?.name,
              })}
            </Text>
          </AlertDialogBase>
        )}
      </View>
    );
  }
}

const styles = StyleSheet.create({
  wrapper: {
    // flex: 1,
    flexDirection: "row",
  },
  iconsWrapper: {
    flex: 1,
    flexDirection: "row",
    justifyContent: "space-evenly",
    alignItems: "center",
    flexWrap: "wrap",
    // borderColor: "#66999977",
    // borderWidth: 1,
    overflow: "hidden",
  },
  modalInsideWrapper: {
    flex: 1,
    padding: 10,
    width: "100%",
  },
  modalFilterWrapper: {
    marginTop: 15,
  },
  modalBtn: {
    flex: 1,
  },
  btnAddShortcut: {
    justifyContent: "center",
    alignItems: "center",
  },
  btnEditShortcut: {
    width: 20,
    height: 20,
    justifyContent: "center",
    alignItems: "center",
    marginHorizontal: 5,
    backgroundColor: ArTheme.COLORS.DEFAULT,
    padding: 3,
    borderRadius: 3,
  },
});

const mapStateToProps = (state) => {
  return {
    DeviceReducer: state.DeviceReducer,
    UserReducer: state.UserReducer,
    AreaReducer: state.AreaReducer,
    ScenarioReducer: state.ScenarioReducer,
    AppReducer: state.AppReducer,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    refreshQuickAccessList: (accessToken) =>
      dispatch(UserActions.RefreshQuickAccessList(accessToken)),
    updateQuickAccessList: (devicesIdList, accessToken) =>
      dispatch(UserActions.UpdateQuickAccessList(devicesIdList, accessToken)),
    updateQuickAccessListLocally: (devices) =>
      dispatch(UserActions.UpdateQuickAccessListLocally(devices)),
    turnOffAllLights: (accessToken, areaId = 0, areaUId = null) =>
      dispatch(AreaActions.changeLights(areaId, areaUId, false, accessToken)),
    openAllCurtains: (accessToken, areaId = null) =>
      dispatch(AreaActions.openCurtains(areaId, accessToken)),
    closeAllCurtains: (accessToken, areaId = null) =>
      dispatch(AreaActions.closeCurtains(areaId, accessToken)),
    turnOnAllHvacs: (accessToken, areaId = 0, areaUId = null) =>
      dispatch(AreaActions.changeHVACs(areaId, areaUId, true, accessToken)),
    turnOffAllHvacs: (accessToken, areaId = 0, areaUId = null) =>
      dispatch(AreaActions.changeHVACs(areaId, areaUId, false, accessToken)),
    unlockDoorLock: (deviceId, deviceUId, accessToken) =>
      dispatch(DoorlockActions.Unlock(deviceId, deviceUId, accessToken)),
    runScenario: (scenarioId, scenarioUId, accessToken) =>
      dispatch(
        ScenarioActions.RunScenario(scenarioId, scenarioUId, accessToken)
      ),
    activateState: (stateId, stateUId, accessToken) =>
      dispatch(AreaActions.ActivateState(stateId, stateUId, accessToken)),
    deActivateState: (stateId, stateUId, accessToken) =>
      dispatch(AreaActions.DeActivateState(stateId, stateUId, accessToken)),
    turnOffSirenValue: (deviceId, accessToken) =>
      dispatch(SirenActions.turnOff(deviceId, accessToken)),
    // === Notification toast  ===
    messageToast: (message) => dispatch(AppActions.messageToast(message)),
    clearRunResult: () => dispatch(ScenarioActions.clearRunResult()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ShortcutBoard);
